export const divisionInfo = (t: any) => {
  return [
    {
      id: 1,
      divisionId: 2,
      name: t('DASHBOARD.SUMMARY.DHAKA'),
    },
    {
      id: 2,
      divisionId: 3,
      name: t('DASHBOARD.SUMMARY.CHATTOGRAM'),
    },
    {
      id: 3,
      divisionId: 5,
      name: t('DASHBOARD.SUMMARY.KHULNA'),
    },
    {
      id: 4,
      divisionId: 7,
      name: t('DASHBOARD.SUMMARY.SYLHET'),
    },
    {
      id: 5,
      divisionId: 9,
      name: t('DASHBOARD.SUMMARY.MYMENSINGH'),
    },
    {
      id: 6,
      divisionId: 4,
      name: t('DASHBOARD.SUMMARY.RAJSHAHI'),
    },
    {
      id: 7,
      divisionId: 8,
      name: t('DASHBOARD.SUMMARY.RANGPUR'),
    },
    {
      id: 8,
      divisionId: 6,
      name: t('DASHBOARD.SUMMARY.BARISHAL'),
    },
  ];
};
